import {vnTemplate} from "../../../vendor/valnet/valnet_jslib/vnKnockoutJsTemplates/vnTemplate";

declare var ko: any;

export class jobProfilesView_template extends vnTemplate{

    protected getTemplateHtml(): string{

        return `

                <div class="w-form w-form-large">
                
                    <div class="form-header">
                        <button data-bind="event: { click: onClickCancel }" class="btn icon i-back" type="button">Go Back</button> 
                        <button data-bind="event: { click: onClickEdit   }, visible: isEditShown" class="btn icon i-edit" type="button">Edit Profile</button>    
                    </div>
                    
                    <div class="w-form-body">
                        <div class="form-body">
                            <strong class="form-sub-title">General</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Status</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: isActive"></span>
                                    </dd>
                                    <dt>
                                        <span>Last Date Enabled</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: lastDateEnabled"></span>
                                    </dd>
                                    
                                    <dt>
                                        <span>LAst Date Disabled</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: lastDateDisabled"></span>
                                    </dd>
                                    
                                    <dt>
                                        <span>Date Created</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: dateCreated"></span>
                                    </dd> 
                                </dl>
                            </div>
                            <strong class="form-sub-title">Public Information</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Position Title</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: name"></span>
                                    </dd>
                                    <dt>
                                        <span>Brand</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: brand"></span>
                                    </dd>
                                    <dt>
                                        <span>Location</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: location"></span>
                                    </dd>
                                    <dt>
                                        <span>Availability</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: availability"></span>
                                    </dd>
                                    <dt>
                                        <span>Experience</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: experience"></span>
                                    </dd>
                                    
                                </dl>
                            </div>
                            <div class="form-group">
                                <span class="form-label underline">Website Description</span>
                                <div class="rich-text" data-bind="html: longDescription"></div>
                            </div>
                            <div class="form-group">
                                <span class="form-label underline">Emaki Description</span>
                                <div class="rich-text"><p data-bind="html: additionalText"></p></div>
                            </div>
                        </div>
                        
                        <div class="form-body">
                            <strong class="form-sub-title">Configuration</strong>
                            <div class="form-group">
                                <dl class="double-list">
                                       
                                    <dt>
                                        <span>Role</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: role"></span>
                                    </dd>
                                    
                                    <dt>
                                        <span>Network Category</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: networkCategory"></span>
                                    </dd>
                                    
                                    <dt>
                                        <span>Permitted GEOs</span>
                                    </dt>
                                    <dd data-bind="foreach: geos">
                                        <span data-bind="text: name + ','"></span>
                                    </dd>
                                </dl> 
                            </div> 
                            
                            <div class="form-group">
                                <hr class="form-hr">
                            </div>
                            
                            <div class="form-group">      
                                <dl class="double-list">    
                                    <dt>
                                        <span>Resume</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: resume"></span>
                                    </dd>
                                    
                                    <dt>
                                        <span>Cover Letter</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: coverLetter"></span>
                                    </dd>                                                           
                                </dl>
                               
                            </div>
                            <div class="form-group">
                                <hr class="form-hr">
                            </div>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Links to Referential Work</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: referentialWork"></span>
                                    </dd>
                                </dl>
                            </div>
                            <div class="form-group">
                                <span class="form-label underline">Referential Work Instructions</span>
                                <div class="rich-text" data-bind="html: referentialWorkInstructions"></div>
                            </div>
                            <div class="form-group">
                                <hr class="form-hr">
                            </div>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Written Sample</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: writtenSample"></span>
                                    </dd> 
                                </dl>
                            </div>
                            <div class="form-group">
                                <span class="form-label underline">Written Sample Instructions</span>
                                <div class="rich-text" data-bind="html: writtenSampleInstructions"></div>
                            </div>
                            <div class="form-group">
                                <hr class="form-hr">
                            </div>
                            <div class="form-group">
                                <dl class="double-list">
                                    <dt>
                                        <span>Image Sample</span>
                                    </dt>
                                    <dd>
                                        <span data-bind="text: imageSample"></span>
                                    </dd> 
                                </dl>
                            </div>
                            <div class="form-group">
                                <span class="form-label underline">Image Sample Instructions</span>
                                <div class="rich-text" data-bind="html: imageSampleInstructions"></div>
                            </div>
                            <div class="form-group">
                                <hr class="form-hr">
                            </div>
                            <div class="form-group">
                                <span class="form-label underline">Questions</span>
      
                                <dl class="double-list" data-bind="foreach: questions()">
                                    <dt class="full-width">
                                        <span data-bind="text: $parent.configOptions().length == 0 ? 'None' : $parent.configOptions().find(function(e) {if(e.id == id){return e}}).name"></span>
                                    </dt>
                                    <dd class="full-width">
                                        <span data-bind="html: question"> </span>
                                    </dd>
                                </dl>
                            </div>
                        </div>
                    </div>
                    
                </div>
 
                `;
    }

    protected initPartial(): void{

    }

    protected getTemplateName(): string{

        return "jobProfile_template";
    }

    protected buildViewModel(): any{

        let huit_neuf_this = this;

        return{
             id: ko.observable("")
            , name: ko.observable("")
            , brand: ko.observable("")
            , location: ko.observable("")
            , availability: ko.observable("")
            , experience: ko.observable("")
            , longDescription: ko.observable("")
            , additionalText: ko.observable("")
            , role: ko.observable("")
            , networkCategory: ko.observable("")
            , geos: ko.observableArray([])
            , resume: ko.observable("")
            , coverLetter: ko.observable("")
            , referentialWork: ko.observable("")
            , referentialWorkInstructions: ko.observable("")
            , writtenSample: ko.observable("")
            , writtenSampleInstructions: ko.observable("")
            , imageSample: ko.observable("")
            , imageSampleInstructions: ko.observable("")
            , questions: ko.observableArray([])
            , position: ko.observable("")
            , imageUrl: ko.observable("")
            , isActive: ko.observable("")
            , lastDateEnabled: ko.observable("")
            , lastDateDisabled: ko.observable("")
            , dateCreated: ko.observable("")
            , isEditShown: ko.observable(false)
            , configOptions: ko.observableArray([])
            , lockItem: ko.observable(false)
            , onClickEdit: function (data){huit_neuf_this.onClickEdit(data.id());}
            , onClickCancel: function (data, event){huit_neuf_this.onClickCancel();}
        }
    }

    public getViewModelForRequest() {

        return {
            lockItem : this.getTemplateViewModel().lockItem
        }
    }

    public onClickEdit(id){

        this.caller.edit(id);
    }

    protected onClickCancel(){

        this.caller.goBack();
    }

    public setId(id): void{

        this.getTemplateViewModel().id(id);
    }

    public setName(name): void{

        this.getTemplateViewModel().name(name);
    }

    public setBrand(name): void{

        this.getTemplateViewModel().brand(name);
    }

    public setLocation(location): void{

        this.getTemplateViewModel().location(location);
    }

    public setAvailability(availability): void{

        this.getTemplateViewModel().availability(availability);
    }

    public setExperience(experience): void{

        this.getTemplateViewModel().experience(experience);
    }

    public setLongDescription(longDesc): void{

        this.getTemplateViewModel().longDescription(longDesc);
    }

    public setAdditionalText(additionalText): void{

        this.getTemplateViewModel().additionalText(additionalText);
    }

    public setRole(role): void{

        this.getTemplateViewModel().role(role.name);
    }

    public setNetworkCategory(networkCategory): void{

        this.getTemplateViewModel().networkCategory(networkCategory.name);
    }

    public setGeos(geos): void{

        this.getTemplateViewModel().geos(geos);
    }

    public setResume(resume): void{

        this.getTemplateViewModel().resume(resume);
    }

    public setCoverLetter(coverLetter): void{

        this.getTemplateViewModel().coverLetter(coverLetter);
    }

    public setReferentialWork(referentialWork): void{

        this.getTemplateViewModel().referentialWork(referentialWork);
    }

    public setReferentialWorkInstructions(instructions): void{

        this.getTemplateViewModel().referentialWorkInstructions(instructions);
    }

    public setWrittenSample(writtenSample): void{

        this.getTemplateViewModel().writtenSample(writtenSample);
    }

    public setWrittenSampleInstructions(instructions): void{

        this.getTemplateViewModel().writtenSampleInstructions(instructions);
    }

    public setImageSample(imageSample): void{

        this.getTemplateViewModel().imageSample(imageSample);
    }

    public setImageSampleInstructions(instructions): void{

        this.getTemplateViewModel().imageSampleInstructions(instructions);
    }

    public setQuestions(questions): void{

        this.getTemplateViewModel().questions(questions);
    }

    public setPosition(position): void{

        this.getTemplateViewModel().position(position);
    }

    public setImageUrl(imageUrl): void{

        this.getTemplateViewModel().imageUrl(imageUrl);
    }

    public setIsActive(isActive): void{

        this.getTemplateViewModel().isActive(isActive);
    }

    public setLastDateEnabled(lastDateEnabled): void{

        this.getTemplateViewModel().lastDateEnabled(lastDateEnabled);
    }

    public setLastDateDisabled(lastDateDisabled): void{

        this.getTemplateViewModel().lastDateDisabled(lastDateDisabled);
    }

    public setDateCreated(dateCreated): void{

        this.getTemplateViewModel().dateCreated(dateCreated);
    }

    public setIsEditShown(isEditShown): void{

        this.getTemplateViewModel().isEditShown(isEditShown);
    }

    public setConfigOptions(options): void{

        this.getTemplateViewModel().configOptions(options);
    }
}


// WEBPACK FOOTER //
// ./js/components/templates/jobProfilesView_template.ts